import React from 'react';
import { MicOff } from 'lucide-react';

const FONT = "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif";

/** Shown when the recorder stopped but produced no audio data (muted mic, device taken by another app). */
export function NoAudioPanel({ onRecordAgain, onSkip, testIdPrefix = 'no-audio' }) {
  return (
    <div style={{ textAlign: 'center', width: '100%', maxWidth: '440px', fontFamily: FONT }} data-testid={testIdPrefix}>
      <div style={{ width: '76px', height: '76px', borderRadius: '50%', background: '#fef3c7', border: '4px solid #d97706', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
        <MicOff size={32} color="#b45309" />
      </div>
      <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#b45309', marginBottom: '8px' }}>We didn't capture any audio</div>
      <div style={{ fontSize: '13px', color: '#34495e', marginBottom: '14px', lineHeight: '1.55' }}>
        The recording finished but it was empty. This usually means the microphone is <strong>muted at the system level</strong>, another app (Zoom, Teams, WhatsApp) is using it, or a Bluetooth headset switched off mid-way.
        Check the mic, then record this answer again — nothing has been submitted yet.
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button onClick={onRecordAgain} style={{ background: '#2563eb', color: '#fff', border: 'none', padding: '10px 24px', fontSize: '13px', fontWeight: 'bold', borderRadius: '4px', cursor: 'pointer', fontFamily: FONT }} data-testid={`${testIdPrefix}-record-again-btn`}>
          Record again
        </button>
        {onSkip && (
          <button onClick={onSkip} style={{ background: '#64748b', color: '#fff', border: 'none', padding: '10px 22px', fontSize: '13px', borderRadius: '4px', cursor: 'pointer', fontFamily: FONT }} data-testid={`${testIdPrefix}-skip-btn`}>
            Skip this question
          </button>
        )}
      </div>
    </div>
  );
}
